
import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { iconos } from '../../../data';



export const AlertConIconTitulo = ({ titulo, icono, subtitulo }) => {


    return (

        <Box sx={{textAlign: 'center', py: 5, px: 2, backgroundColor: alpha('#f5f5f5', 0.5), borderRadius: 2}}>
            {React.cloneElement(iconos[icono], {style:{fontSize:60, color:'text.disabled', opacity:0.5} })}
            <Typography variant="h6" color="text.secondary" gutterBottom>
                { titulo }
            </Typography>
            <Typography variant="body2" color="text.disabled">
                { subtitulo }
            </Typography>
        </Box>

    )
}
